(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ss-legal-guarantee"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ss-legal-guarantee')) {
  class SSLegalGuarantee extends HTMLElement {
    connectedCallback() {
      if (this.ssBound) return;
      this.ssBound = true;
      this.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-ss-guarantee-open]');
        if (!trigger || typeof HTMLDialogElement === 'undefined') return;
        event.preventDefault();
        if (document.querySelector('.ss-guarantee__dialog[open]')) return;
        const dialog = this.querySelector('template').content.querySelector('dialog').cloneNode(true);
        const drawer = this.closest('cart-drawer');
        const oldOverflow = document.body.style.overflow;
        if (drawer && typeof removeTrapFocus === 'function') removeTrapFocus();
        document.body.appendChild(dialog);
        const close = () => dialog.close();
        dialog.querySelectorAll('[data-ss-guarantee-close]').forEach((button) => button.addEventListener('click', close));
        dialog.addEventListener('click', (e) => { if (e.target === dialog) close(); });
        const zoom = dialog.querySelector('[data-ss-guarantee-zoom]');
        const zoomLabel = zoom.textContent;
        zoom.addEventListener('click', () => {
          const active = dialog.querySelector('.ss-guarantee__image-scroll').classList.toggle('is-zoomed');
          zoom.setAttribute('aria-pressed', String(active));
          zoom.textContent = active ? zoom.dataset.reset : zoomLabel;
        });
        dialog.addEventListener('close', () => {
          document.body.style.overflow = oldOverflow;
          dialog.remove();
          if (drawer && drawer.isConnected && drawer.classList.contains('active') && typeof trapFocus === 'function') {
            trapFocus(drawer.querySelector('#CartDrawer'), trigger.isConnected ? trigger : drawer.querySelector('.drawer__close'));
          } else if (trigger.isConnected) trigger.focus();
        }, { once:true });
        dialog.showModal();
        document.body.style.overflow = 'hidden';
        dialog.querySelector('[data-ss-guarantee-close]').focus();
      });
    }
  }
  customElements.define('ss-legal-guarantee', SSLegalGuarantee);
}
  } catch(e) { console.error(e); }
})();

})();
